var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (canEditPhrases) { 
__p+='\n  <div class="switch-container">\n    <span>'+
((__t=( switchMessage ))==null?'':_.escape(__t))+
'</span>\n    <input type="checkbox"'+
((__t=( liveEdit ? ' checked' : '' ))==null?'':_.escape(__t))+
' data-js="live-edit-switch"/>\n  </div>\n';
 } 
__p+='\n';
}
return __p;
};
